module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-backward-527367d6.svg";